<!--  -->
<template>
<router-view></router-view>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {

};
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//方法集合
methods: {

},
}
</script>
<style lang='less'>
//@import url(); 引入公共css类

</style>


// WEBPACK FOOTER //
// src/page/resourceManage/index.vue